import { ApiRequestStatus } from '../../../core/models/api/api-request-status'
import { useSnackStore } from '../../../stores/snack.store'
import useDelete from '../../../core/composables/api/useDelete'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'
import usePost from '../../../core/composables/api/usePost'

export const useMutateCoachees = () => {
  const snackStore = useSnackStore()
  const coachingsAddedBus = useEventBus(EventKey.coachingsAdded)

  const coachingDeletedBus = useEventBus(EventKey.coachingDeleted)

  const deleteCoaching = async (coacheeId: string) => {
    const { remove, status: deleteCoachingStatus } = useDelete(`coaching/${coacheeId}`)

    await remove({})

    if (deleteCoachingStatus.value == ApiRequestStatus.Success) {
      coachingDeletedBus.emit({ coacheeId: coacheeId })
      snackStore.showInfo('Coaching wurde beendet.')
    } else {
      snackStore.showError('Ein Fehler ist aufgetreten.')
    }
  }

  const addCoachees = async (coacheeIds: string[]) => {
    const { mutate, status: addCoachingStatus } = usePost<void, { coacheeIds: string[] }>(
      'coaching/coachees',
    )

    await mutate({ coacheeIds })

    if (addCoachingStatus.value == ApiRequestStatus.Success) {
      coachingsAddedBus.emit({ coacheeIds: coacheeIds })
      snackStore.showInfo('Coaching wurde hinzugefügt.')
    } else {
      snackStore.showError('Ein Fehler ist aufgetreten.')
    }
  }

  return {
    deleteCoaching,
    addCoachees,
  }
}
